// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Administrator.css */

/* Variables de couleurs basées sur ton design */
:root {
    --brand-blue: #4318FF;
    --navy-blue: #2B3674;
    --secondary-grey: #A3AED0;
    --bg-light: #F4F7FE;
    --success-green: #05CD99;
    --error-red: #EE5D50;
    --warning-orange: #FFB547;
}

/* Styles pour la table principale */
.admin-table-container {
    padding: 24px;
    border-radius: 20px;
    box-shadow: 0px 20px 40px rgba(112, 144, 176, 0.08);
    background-color: #ffffff;
}

.table-header-cell {
    color: var(--secondary-grey) !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    font-size: 12px;
}

.user-name {
    font-weight: 700;
    color: var(--navy-blue);
}

/* Styles pour le Drawer */
.drawer-paper {
    background-color: var(--bg-light) !important;
}

.drawer-header {
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border-bottom: 1px solid #E0E5F2;
}

/* Cartes de détails (View Mode) */
.detail-card {
    padding: 16px;
    border-radius: 20px;
    background-color: #ffffff;
    margin-bottom: 16px;
}

.stat-box {
    padding: 16px;
    border-radius: 15px;
    text-align: center;
    background-color: #ffffff;
}

/* Avatars et Images */
.profile-avatar-large {
    width: 100px;
    height: 100px;
    margin: 0 auto 16px;
    border: 4px solid #ffffff;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
}

.table-avatar {
    border-radius: 12px;
    width: 40px;
    height: 40px;
}

/* Inputs personnalisés (Optionnel - pour uniformiser MUI) */
.custom-textfield .MuiOutlinedInput-root {
    border-radius: 12px;
}

/* Footer du Drawer */
.drawer-footer {
    padding: 24px;
    background-color: #ffffff;
    border-top: 1px solid #E0E5F2;
    position: sticky;
    bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Adminstrateur/Administrator.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,gDAAgD;AAChD;IACI,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,0BAA0B;AAC1B;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA,4DAA4D;AAC5D;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;AACb","sourcesContent":["/* Administrator.css */\n\n/* Variables de couleurs basées sur ton design */\n:root {\n    --brand-blue: #4318FF;\n    --navy-blue: #2B3674;\n    --secondary-grey: #A3AED0;\n    --bg-light: #F4F7FE;\n    --success-green: #05CD99;\n    --error-red: #EE5D50;\n    --warning-orange: #FFB547;\n}\n\n/* Styles pour la table principale */\n.admin-table-container {\n    padding: 24px;\n    border-radius: 20px;\n    box-shadow: 0px 20px 40px rgba(112, 144, 176, 0.08);\n    background-color: #ffffff;\n}\n\n.table-header-cell {\n    color: var(--secondary-grey) !important;\n    font-weight: 700 !important;\n    text-transform: uppercase;\n    font-size: 12px;\n}\n\n.user-name {\n    font-weight: 700;\n    color: var(--navy-blue);\n}\n\n/* Styles pour le Drawer */\n.drawer-paper {\n    background-color: var(--bg-light) !important;\n}\n\n.drawer-header {\n    padding: 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #ffffff;\n    border-bottom: 1px solid #E0E5F2;\n}\n\n/* Cartes de détails (View Mode) */\n.detail-card {\n    padding: 16px;\n    border-radius: 20px;\n    background-color: #ffffff;\n    margin-bottom: 16px;\n}\n\n.stat-box {\n    padding: 16px;\n    border-radius: 15px;\n    text-align: center;\n    background-color: #ffffff;\n}\n\n/* Avatars et Images */\n.profile-avatar-large {\n    width: 100px;\n    height: 100px;\n    margin: 0 auto 16px;\n    border: 4px solid #ffffff;\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);\n}\n\n.table-avatar {\n    border-radius: 12px;\n    width: 40px;\n    height: 40px;\n}\n\n/* Inputs personnalisés (Optionnel - pour uniformiser MUI) */\n.custom-textfield .MuiOutlinedInput-root {\n    border-radius: 12px;\n}\n\n/* Footer du Drawer */\n.drawer-footer {\n    padding: 24px;\n    background-color: #ffffff;\n    border-top: 1px solid #E0E5F2;\n    position: sticky;\n    bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
